import { Link } from "react-router-dom";
import Logo from "./Logo";

const Footer = () => {
  return (
    <footer
      className="border-t border-gray-100 py-12 bg-white"
      data-testid="site-footer"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
        <div>
          <Logo />
          <p className="mt-3 text-sm text-[#4a5f53] max-w-md">
            Un plan simple. Un suivi réel. Moins de conflits.
          </p>
        </div>
        <div className="flex flex-wrap items-center gap-x-6 gap-y-2 text-sm text-[#4a5f53]">
          <a href="/#fonctionnement" className="hover:text-[#122118] transition-colors">
            Fonctionnement
          </a>
          <a href="/#tarifs" className="hover:text-[#122118] transition-colors">
            Tarifs
          </a>
          <a href="/#faq" className="hover:text-[#122118] transition-colors">
            FAQ
          </a>
          <a href="mailto:bonjour@tuteurvirtuel.ca" className="hover:text-[#122118] transition-colors" data-testid="footer-contact-email">
            Contact
          </a>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-6 lg:px-8 mt-8 flex flex-col gap-2 text-xs text-gray-400 md:flex-row md:items-center md:justify-between">
        <p data-testid="footer-copyright">
          © {new Date().getFullYear()} Plan Étude. Tous droits réservés. · 9571-3681 Québec inc. · v0.2.2
        </p>
        <p className="flex flex-wrap items-center gap-x-1.5">
          <Link to="/confidentialite" className="hover:text-[#122118] transition-colors" data-testid="footer-privacy">
            Politique de confidentialité
          </Link>
          ·
          <Link to="/conditions-utilisation" className="hover:text-[#122118] transition-colors" data-testid="footer-terms">
            Conditions d’utilisation
          </Link>
          ·
          <a href="mailto:bonjour@tuteurvirtuel.ca" className="hover:text-[#122118] transition-colors" data-testid="footer-contact-us">
            Nous contacter
          </a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
